<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
           src=img/avatars/9.jpg
            
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    >
      <strong>Settings</strong>
    </CDropdownHeader>
    <!-- <CDropdownItem>
      <CIcon name="cil-user" /> Profile
      
    </CDropdownItem> -->
    <CDropdownItem>
      <CIcon name="cil-settings"/> Settings
    </CDropdownItem>
    <!-- <CDropdownItem>
      <CIcon name="cil-file" /> Projects
      <CBadge color="primary" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem> -->
    <CDropdownDivider/>
    <CDropdownItem  @click="logoutUser()">
      <CIcon name="cil-lock-locked" />
       Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>

import * as firebase from "firebase/app";
import "firebase/auth";
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      itemsCount: 42
    }
  },
  methods:{
    logoutUser(){
      console.log("onlogout","call logout");
      firebase.auth().signOut().then(()=>{
         console.log("signed out");
      });
    },
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>